import classnames from "classnames";
import { useAppSelector } from "@web-solutions/store/types";

import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import { Text, Title } from "@web-solutions/core/ui-elements";

import { LString, T, t, tm, TM } from "@web-solutions/module-localization";

import { PaymentModalType } from "core/constants/remote-config";

import { useRemoteConfig } from "core/hooks/use-remote-config";
import { useTimer } from "core/payment/hooks/use-timer";
import { ProductDetails, selectPaymentSystem } from "core/store/billing/selectors";

import EmailEditor from "../../components/edit-email-field";

import { Prices } from "./components/prices";

import { SimpleView } from "./components/simple-view";
import { getActualPrices } from "./components/simple-view/utilts";
import { TrialInfoBlock } from "./components/trial-info-block";

import classes from "./style.module.scss";
import report from "./ethnicityReport.png";
import { PaymentSystem } from "@web-solutions/react-billing";

const tKey = "core.payment_popup";

interface ProductInfoProps {
  product: ProductDetails;
  subtitle?: React.ReactNode;
  isSimpleView?: boolean;
}

export const ProductInfo: React.FC<ProductInfoProps> = ({
  product,
  subtitle,
  isSimpleView,
}) => {
  const { title, textLineThrough, discount, isOneTimePurchase, isTrial } =
    product;

  const {
    paymentModalHeader,
    showPricesBlock,
    totalPriceType,
    paymentModalType,
    promocodeOffer,
    paymentModalEmailEnabled,
    simpleTitleModal,
    trialInfoBlock,
    paymentPopup,
    newPaymentModal,
    changePaymentMethod
  } = useRemoteConfig();

  const promocodeActivated = useSelector(
    (state: any) => state.billing.promocodeActivated
  );

  const locale = useAppSelector((state) => state.locale.locale);
  const paymentSystem = useSelector(selectPaymentSystem);

  const { vat, vatPrice, price, fullPrice, actualPrice } = getActualPrices({
    activeProduct: product,
    totalPriceType,
  });
  const titleText = product.title?.[locale] || "";

  const timer = useTimer();
  const isShownTimerBlock = !!discount && timer?.shown;

  const isSimpleModal = paymentModalType === PaymentModalType.SIMPLE;
  const isSimpleTitleModal = paymentModalType === PaymentModalType.SIMPLE_TITLE;

  const paymentModalHeaderParams = { titleText, ...product };
  const params = new URLSearchParams(window.location.search);
  const flowParam = params.get("flow");
  const isChangePaymentMethod = flowParam === "change-payment-method";
  

  return (
    <div
      className={classnames(classes.wrap, { [classes.simple]: isSimpleView })}
    >
      {isOneTimePurchase || isChangePaymentMethod ? (
        <>
        <div className={classes.row} style={{marginTop: '20px', paddingBottom: '10px'}}>
          <p className={classes.titleNew}>
            {tm(title?.[locale as keyof LString], "")}
          </p>
          <p className={classes.titleNew}>
            {!!textLineThrough && (
              <span className={classes.lineThrough}>
                {tm(textLineThrough, "", product)}
              </span>
            )}
           ${price}
          </p>
          
        </div>
        <div
        className={
          newPaymentModal ? classes.dividerNew : classes.divider
        }
      />
        <div className={classes.row} style={{marginTop: '20px', paddingBottom: '10px'}}>
          <p
            className={
              newPaymentModal
                ? classes.smallTextNew
                : classes.aboutItemBlackText
            }
          >
            <T
              k={paymentPopup.total["today"][locale]}
              components={{ span: <span className={classes.smallText} /> }}
            />
          </p>
          <p
            className={
                classes.smallTextNew
            }
          >
           ${price}
          </p>
        </div>
        <div
        className={
          newPaymentModal ? classes.dividerNew : classes.divider
        }
      />
      <EmailEditor isSimpleView={isSimpleView} showEdit={false} />

      </>
      ) : (
        <>
          {!(isSimpleModal || isSimpleTitleModal) ? (
            <>
              <div
                className={newPaymentModal ? classes.blockNew : classes.block}
              >
                <div className={classes.headerWrapper}>
                  {paymentModalHeader?.title && (
                    <Title level="h3" className={classes.modalTitle}>
                      <TM
                        k={paymentModalHeader.title}
                        tOptions={paymentModalHeaderParams}
                      />
                    </Title>
                  )}

                  {/* title */}
                  {newPaymentModal ? (
                    <div className={classes.modalSubtitle}>
                      <div className={classes.titleReservedNew}>
                        {t('onboarding.paymentModal.timer')} <Timer />
                      </div>
                    </div>
                  ) : (
                    <div className={classes.modalSubtitle}>
                      <div className={classes.titleReserved}>
                      {t('onboarding.paymentModal.yourDisctount')}{' '}<Timer />{' '}{t('onboarding.paymentModal.min')}
                      </div>
                    </div>
                  )}

                  {/* {tm(
                      paymentModalHeader?.subtitle,
                      paymentPopup.selectedTitles[locale],
                      paymentModalHeaderParams,
                    )} */}
                    
                </div>
                {subtitle}
                {(promocodeActivated ||
                  (!promocodeOffer.enabled &&
                    promocodeOffer.switchDefaultValue)) && (
                  <div className={classes.promocode}>
                    <span>🎁</span>
                    {t(`${tKey}.promocode.text`)}
                  </div>
                )}
                {paymentModalType === PaymentModalType.BOTTOM_INJECTED &&
                  discount && (
                    <div className={classes.specialOffer}>
                      <div className={classes.title}>
                        {t(`${tKey}.modal_discount.title`)}
                      </div>
                      <div className={classes.text}>
                        {t(`${tKey}.modal_discount.text`, { discount })}
                      </div>
                    </div>
                  )}
                {isShownTimerBlock && !newPaymentModal && (
                  <div className={classes.row}>
                    <p className={classes.discountTitle}>
                      {t(
                        `${tKey}.${timer?.shown ? (discount ? "discount" : "discount_zero") : "discount_save"}`,
                        { discount }
                      )}
                    </p>
                    {timer?.shown && (
                      <div className={classes.discount}>{timer?.text}</div>
                    )}
                  </div>
                )}
              </div>

              {!newPaymentModal && <div className={classes.divider} />}

              {showPricesBlock && (
                <Prices product={product} priceText={price} />
              )}
            </>
          ) : (
            <>
              <SimpleView
                showPrice={!simpleTitleModal?.withTotalPriceUnder}
                fullPrice={fullPrice}
                actualPrice={actualPrice}
                discount={discount}
                vatPrice={vatPrice}
                vat={vat}
                discountPrice={product?.savedPrice || ""}
                mode={isSimpleTitleModal ? simpleTitleModal?.type : undefined}
              />
            </>
          )}
          {paymentModalEmailEnabled && (paymentSystem === PaymentSystem.RECURLY || paymentSystem === PaymentSystem.TRUEGATE || (paymentSystem === PaymentSystem.SOLIDGATE || product.isOneTimePurchase)) && (
            <>
              <div
                className={
                  newPaymentModal ? classes.dividerNew : classes.divider
                }
              />
              <EmailEditor isSimpleView={isSimpleView} />
              {/* {newPaymentModal && (<div className={classes.reportInfo}>
                <img src={report} alt="report" />
                <p>
                {t('onboarding.paymentModal.weWillSend')}{" "}
                  <span>{t('onboarding.paymentModal.report')}</span>
                  <br />
                  {t('onboarding.paymentModal.onEmail')}
                </p>
              </div>)} */}
            </>
          )}
          {trialInfoBlock.show && isTrial && (
            <TrialInfoBlock
              product={product}
              periodMode={trialInfoBlock.periodMode}
            />
          )}
        </>
      )}
    </div>
  );
};

export const Timer = () => {
  const [timeLeft, setTimeLeft] = useState(595);
  const [isTimerVisible, setIsTimerVisible] = useState(true);

  const { newPaymentModal } = useRemoteConfig();

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          setIsTimerVisible(false);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  return (
    <>
      {newPaymentModal ? (
        <div className={classes.timerWrapper}>
          <span style={{ color: "#007CFF" }}>{formatTime(timeLeft)}</span>
        </div>
      ) : (
        <span style={{ color: "#E768B0" }}>{formatTime(timeLeft)}</span>
      )}
    </>
  );
};
